import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseProjectsBusinessUnitDemandPayload } from '../payloads/projectsBusinessUnitDemandPayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import intl from 'react-intl-universal';

export const buildProjectsBusinessUnitDemandInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseProjectsBusinessUnitDemandPayload(payload);
  const { data } = parsedPayload.data.attributes;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.V_BAR_STACK_LINE)
      .setProps({
        chartData: data as BarChartData,
        onDrillDown: props.onDrillDown,
        xAxisFieldName: 'business_unit_title',
        yAxisFieldNames: [
          'projects_without_tasks',
          'partially_scoped_projects',
          'fully_scoped_projects',
        ],
        legendNames: [
          intl.get('INSIGHT.LEGEND.PROJECTS_WITHOUT_TASKS'),
          intl.get('INSIGHT.LEGEND.PARTIALLY_SCOPED_PROJECTS'),
          intl.get('INSIGHT.LEGEND.FULLY_SCOPED_PROJECTS'),
        ],
        stacks: ['projects', 'projects', 'projects'],
        lineFieldNames: ['total_demand_hours'],
        lineLegendNames: [intl.get('INSIGHT.LEGEND.TOTAL_DEMAND_HOURS')],
        lineAxisName: intl.get('INSIGHT.AXIS.DEMAND_HOURS'),
        barAxisName: intl.get('INSIGHT.AXIS.NUMBER_OF_PROJECTS'),
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
